export function Card({ children, className = '', ...props }) {
  return (
    <div
      className={`bg-bg-card border border-border/40 rounded-xl p-5 transition-shadow duration-200 ${className}`}
      style={{ boxShadow: 'var(--shadow-card)' }}
      {...props}
    >
      {children}
    </div>
  );
}

export function KPICard({ title, value, subtitle, change, changeLabel, icon: Icon, variant = 'default', bare = false }) {
  const isPositive = typeof change === 'number' ? change >= 0 : true;
  const changeColor = variant === 'inverse'
    ? (isPositive ? 'text-danger' : 'text-success')
    : (isPositive ? 'text-success' : 'text-danger');

  const content = (
    <div className="flex items-start justify-between">
      <div className="space-y-1.5">
        <p className="text-text-secondary text-xs font-medium uppercase tracking-wider">{title}</p>
        <p className="text-2xl font-semibold text-text-primary">{value}</p>
        {subtitle && (
          <p className="text-text-muted text-[10px]">{subtitle}</p>
        )}
        {change != null && (
          <p className={`text-sm ${changeColor}`}>
            {typeof change === 'number' ? (change >= 0 ? '+' : '') : ''}{typeof change === 'number' ? change.toFixed(1) + '%' : change}
            {changeLabel && <span className="text-text-muted ml-1">{changeLabel}</span>}
          </p>
        )}
      </div>
      {Icon && (
        <div className="p-2 bg-accent-muted/40 rounded-lg">
          <Icon className="w-5 h-5 text-accent" />
        </div>
      )}
    </div>
  );

  if (bare) return content;
  return <Card>{content}</Card>;
}
